export default __webpack_public_path__ + "static/media/back.38d01ae6.svg";